import React from 'react'; 
import styled from '@emotion/styled' 
import BG from  '../../../../assets/Images/newDesign/BGearth.png'  
import BoxLogo from  '../../../../assets/Images/newDesign/shadowBoxLogo.png' 
import ubantu from  '../../../../assets/Images/newDesign/ubantu.png'  
import andoid from  '../../../../assets/Images/newDesign/android.png'  
import ios from  '../../../../assets/Images/newDesign/ios.png'  
import macos from  '../../../../assets/Images/newDesign/macos.png'   
import window from  '../../../../assets/Images/newDesign/window.png' 
import { Box, Container } from '@mui/material';
import { Img } from '../../../Styles/Maintext.styles'
import Paragraph from '../../Paragraph';
import AvailabilityMenu from './Components/Menu';  
import {motion} from 'framer-motion';

const MainBg = styled.div`
     background-image: url(${BG}); 
     background-position: top; 
     background-size: cover; 
     background-repeat: no-repeat; 
     min-height:${(props) =>  props.h  ? props.h :"500px"};
     overflow: hidden;
`    
const ScndContainer = styled(Container)`
    display: flex;  
    flex-direction: column;
    justify-content: center; 
    align-items: center;
` 
const FlexBox =  styled(Box)` 
  display:flex; 
  flex-direction: column; 
  justify-content: center; 
  align-items: center; 
  gap:10px;
` 

 const main_array =  [
    {  
      name : "Ubuntu", 
      w : "70%",  
      small_w : "62%",
      src  : ubantu,
      arr : [ 
        {
          title: "Ubuntu (Premium)",
          link: 'https://shadownode.org/vpnexe/ubuntu-2.0.0.AppImage',
          target:"blank"
        },
        {
          title: "Ubuntu (Free)",
          link: 'https://remote.shadownode.org/ShadowNodeVPN-1.0.0-linux-amd64.deb',
          target:"blank"
        },

      ]
      }, 
      {  
        name : "Android", 
        w : "70%",  
        small_w : "62%",
        src  : andoid,
        arr : [ 
          {
            title: 'Android TV',
            link: './shadow_node_android_tv.apk',
            target:"blank"
          },
          {
            title: 'Android (Premium)',
            link:'https://play.google.com/store/apps/details?id=com.shadownode.svpn',
            target:"blank"
          }, 
          {
            title: 'Android (Free)',
            link: 'https://play.google.com/store/apps/details?id=com.svpn.freeshadownode',
            target:"blank"
          },
        ]
        },
        {  
          name : "IOS", 
          w : "70%",  
          small_w : "62%",
          src  : ios,
          arr : [ 
            {
              title: 'IOS (Premium)',
              link:'https://testflight.apple.com/join/v6hQPX5p',
              target:"blank"
            },
            {
              title: 'IOS (Free)',
              link:'https://testflight.apple.com/join/lOfDBfgw',
              target:"blank"
            }, 
          ]
          }, 
          {  
            name : "Windows", 
            w : "70%",  
            small_w : "62%",
            src  : window, 
            arr : [ 
              {
                title:'Windows (Premium)',
                link: 'https://shadownode.org/vpnexe/x-64.exe',
                target:"blank"
              },
              {
                title: 'Windows (Free)',
                link:'https://shadownode.org/vpnexe/ShadowNodeVPN_Windows.exe',
                target:"blank"
              }
            ]
            }, 
            {  
              name : "macOS", 
              w : "70%", 
              small_w : "62%", 
              src  : macos,
              arr : [ 
                {
                  title: 'macOS(M1)',
                  link:'https://testflight.apple.com/join/v6hQPX5p',
                  target:"blank"
                },
                {
                  title: 'macOS(M2)',
                  link: 'https://testflight.apple.com/join/v6hQPX5p',
                  target:"blank"
                }
              ]
              },  
 ];
const Motioncontainer = motion(Container);
const Availability = () => { 


  return (
    <MainBg> 
      <div id="stars"></div>
        <div id="stars2"></div>
        <ScndContainer data-aos="fade-up" id="download" sx={{position:"relative",zIndex:"500",paddingTop:{xs:"9%",lg:"7%"},gap:"25px", paddingBottom:{xs:"15%",sm:"0px",md:"0px",lg:"10%"},marginTop:{xs:"10%",sm:"0px",md:"0px",lg:"0px"},marginBottom:{xs:"10%",sm:"0px",md:"0px",lg:"0px"}, paddingLeft:{xs:"20px",sm:"16px",md:"16px",lg:"16px"},paddingRight:{xs:"20px",sm:"16px",md:"16px",lg:"16px"}}}>   
            <FlexBox  sx={{gap:"20px !important"}}> 
                <Img src={BoxLogo} w="40%" alt="BoxLog"  />  
                <Paragraph variant="body1" fontWeight="600">We Are Available On Many Devices</Paragraph>
            </FlexBox> 
            <FlexBox gap="20px !important"> 
                <Paragraph variant="h6"  fontWeight="600">Download Apps</Paragraph> 
                <FlexBox flexDirection="row !important" justifyContent="center" flexWrap='wrap' gap={{xs:"0px !important",lg:"10px"}}>    
                {main_array.map((item) => ( 
                  <AvailabilityMenu key={item.title} src={item.src} name={item.name} w={item.w} small_w={item.small_w} array={item.arr} /> 
               ))}
               </FlexBox>
            </FlexBox> 
        </ScndContainer> 
    </MainBg>
  )
}

export default Availability;


